/* Pertegaz PDP — drives the sticky vertical scroll-state line on the product gallery.
   Track height is fixed (see CSS); the ink thumb's height reflects how much of the gallery
   fits the viewport, and its position reflects how far you've scrolled through the gallery.
   Desktop only; stays hidden / inert on mobile where Dawn's slider is used. */
(function () {
  var TRACK = 240; // must match .pz-pdp__scroll height in CSS

  function clamp(v, min, max) { return v < min ? min : v > max ? max : v; }

  function init() {
    // Track the IMAGE LIST, not the media wrapper: the wrapper is stretched to the info
    // column's height (align-items: stretch), so it extends far past the last image and the
    // line would linger into the section below. The list is exactly the stacked images.
    var list = document.querySelector('.pz-pdp .product__media-list');
    var line = document.querySelector('.pz-pdp__scroll');
    if (!list || !line) return;
    var thumb = line.querySelector('.pz-pdp__scroll-thumb');
    if (!thumb) return;

    var raf = null;

    function update() {
      raf = null;
      if (window.innerWidth < 750) return;
      // The LINE is positioned natively (CSS position:sticky) — no JS. Here we only move the ink
      // thumb to reflect how far through the images you've scrolled.
      var vh = window.innerHeight;
      var r = list.getBoundingClientRect();
      var h = r.height;
      var range = h - vh;
      if (range <= 0) {
        thumb.style.height = TRACK + 'px';
        thumb.style.transform = 'translateY(0)';
        return;
      }
      var progress = clamp(-r.top / range, 0, 1);
      var th = clamp(TRACK * (vh / h), 24, TRACK);
      thumb.style.height = th + 'px';
      thumb.style.transform = 'translateY(' + progress * (TRACK - th) + 'px)';
    }

    function onScroll() {
      if (!raf) raf = requestAnimationFrame(update);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  /* Mobile: horizontal progress line under the full-bleed image slider. The thumb width
     reflects one slide's share; its position reflects the slider's scroll (swipe) progress. */
  function initH() {
    var slider = document.querySelector('.pz-pdp .product__media-list');
    var bar = document.querySelector('.pz-pdp__hbar');
    if (!slider || !bar) return;
    var thumb = bar.querySelector('.pz-pdp__hbar-thumb');
    if (!thumb) return;

    // Pin the line to the exact bottom edge of the media container (the wrapper can carry a
    // stray few px below it, so anchor to the container itself rather than bottom:0).
    function placeBar() {
      var cont = document.querySelector('.pz-pdp .product-media-container');
      var wrap = document.querySelector('.pz-pdp .product__media-wrapper');
      if (!cont || !wrap) return;
      var cr = cont.getBoundingClientRect();
      var wr = wrap.getBoundingClientRect();
      bar.style.top = (cr.bottom - wr.top - 1) + 'px';
      bar.style.bottom = 'auto';
    }

    var raf = null;
    function updateH() {
      placeBar();
      raf = null;
      var sw = slider.scrollWidth, cw = slider.clientWidth;
      var range = sw - cw;
      var trackW = bar.clientWidth;
      if (range <= 4 || trackW <= 0) { thumb.style.width = '0px'; return; }
      var thumbW = clamp(trackW * (cw / sw), 24, trackW);
      var progress = clamp(slider.scrollLeft / range, 0, 1);
      thumb.style.width = thumbW + 'px';
      thumb.style.transform = 'translateX(' + progress * (trackW - thumbW) + 'px)';
    }
    function onScrollH() { if (!raf) raf = requestAnimationFrame(updateH); }
    slider.addEventListener('scroll', onScrollH, { passive: true });
    window.addEventListener('resize', onScrollH);
    updateH();
  }

  /* Color swatches: while hovering a swatch, show that color's name in the label;
     restore the active color's name on leave. */
  function initSwatches() {
    var wrap = document.querySelector('[data-pz-swatches]');
    if (!wrap) return;
    var label = wrap.querySelector('[data-pz-swatch-label]');
    if (!label) return;
    var def = label.textContent;
    var swatches = wrap.querySelectorAll('.pz-swatch');
    for (var i = 0; i < swatches.length; i++) {
      (function (sw) {
        sw.addEventListener('mouseenter', function () {
          var n = sw.getAttribute('data-name');
          if (n) label.textContent = n;
        });
        sw.addEventListener('mouseleave', function () { label.textContent = def; });
      })(swatches[i]);
    }
  }

  /* Size selector. Selection is REQUIRED, but the Add-to-cart button stays black/active with its
     normal "Añadir a la cesta" label; while no size is chosen, hovering or clicking it flips it to
     an inactive grey "Selecciona una talla" state (and the click is blocked). If exactly one size is
     in stock, it's pre-selected. A static "Multisize" line has no buttons and needs no wiring. */
  function initSizes() {
    var box = document.querySelector('[data-pz-sizes]');
    if (!box) return;
    var buttons = box.querySelectorAll('.pz-size:not(.pz-size--static)');
    if (!buttons.length) return; // static Multisize line — nothing to gate

    var form = document.getElementById(box.getAttribute('data-form-id'));
    if (!form) return;
    var idInput = form.querySelector('input[name="id"]');
    var submit = form.querySelector('.product-form__submit');
    var submitText = submit ? submit.querySelector('span') : null;
    var valueOut = box.querySelector('[data-pz-size-value]');
    var lowEl = box.querySelector('[data-pz-size-lowstock]');
    var priceEl = document.querySelector('.pz-pdp [id^="price-"]');
    var lowThreshold = parseInt(box.getAttribute('data-low-threshold'), 10);
    var lowText = box.getAttribute('data-low-text') || 'Últimas unidades';

    var addLabel = (submitText && submitText.textContent.trim()) || ((window.pzI18n&&window.pzI18n.addToCart)||'Añadir a la cesta');
    var WARN = (window.pzI18n&&window.pzI18n.selectSize)||'Selecciona una talla';
    var selected = false;

    function clearWarn() {
      if (submit) { submit.classList.remove('pz-warn'); }
      if (submitText) { submitText.textContent = addLabel; }
    }
    function showWarn() {
      if (submit) { submit.classList.add('pz-warn'); }
      if (submitText) { submitText.textContent = WARN; }
    }

    function selectBtn(btn) {
      for (var j = 0; j < buttons.length; j++) {
        buttons[j].classList.remove('pz-size--active');
        buttons[j].setAttribute('aria-checked', 'false');
      }
      btn.classList.add('pz-size--active');
      btn.setAttribute('aria-checked', 'true');
      if (idInput) { idInput.value = btn.getAttribute('data-variant-id'); idInput.removeAttribute('disabled'); }
      if (valueOut) { valueOut.textContent = btn.getAttribute('data-value'); }
      var p = btn.getAttribute('data-price');
      if (priceEl && p) {
        var regs = priceEl.querySelectorAll('.price-item--regular');
        for (var k = 0; k < regs.length; k++) { regs[k].textContent = p; }
      }
      // low-stock note for this size, e.g. "Talla 14  Últimas unidades"
      if (lowEl) {
        var inv = parseInt(btn.getAttribute('data-inv'), 10);
        var managed = btn.getAttribute('data-inv-managed') === 'shopify';
        if (managed && lowThreshold > 0 && inv > 0 && inv <= lowThreshold) {
          lowEl.textContent = lowText;
        } else {
          lowEl.textContent = '';
        }
      }
      selected = true;
      clearWarn();
    }

    // gather in-stock sizes, wire clicks
    var avail = [];
    for (var i = 0; i < buttons.length; i++) {
      var b = buttons[i];
      if (b.hasAttribute('disabled')) continue; // sold-out size
      avail.push(b);
      (function (btn) { btn.addEventListener('click', function () { selectBtn(btn); }); })(b);
    }

    // pre-select when only one size is in stock; otherwise require an explicit choice
    if (avail.length === 1) {
      selectBtn(avail[0]);
    } else {
      if (idInput) { idInput.value = ''; idInput.setAttribute('disabled', 'disabled'); }
    }

    // keep the button looking active; warn on hover/click until a size is chosen
    if (submit) {
      submit.addEventListener('mouseenter', function () { if (!selected) showWarn(); });
      submit.addEventListener('mouseleave', function () { if (!selected) clearWarn(); });
      // block the add (capture phase, before product-form.js) when nothing is selected
      submit.addEventListener('click', function (e) {
        if (!selected) {
          e.preventDefault();
          e.stopImmediatePropagation();
          showWarn();
        }
      }, true);
    }
  }

  /* Size-guide drawer: open/close the side panel and switch the table between mm and inches. */
  function initSizeGuide() {
    var sg = document.querySelector('[data-pz-sizeguide]');
    if (!sg) return;
    // move to <body> so the fixed drawer escapes the section's stacking context and
    // layers above the header (which otherwise renders on top of it).
    if (sg.parentNode !== document.body) { document.body.appendChild(sg); }
    var openers = document.querySelectorAll('[data-pz-sg-open]');
    var closers = sg.querySelectorAll('[data-pz-sg-close]');

    function open() {
      sg.hidden = false;
      requestAnimationFrame(function () { sg.classList.add('is-open'); });
      document.documentElement.style.overflow = 'hidden';
      document.documentElement.classList.add('pz-sg-open');
    }
    function close() {
      sg.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      document.documentElement.classList.remove('pz-sg-open');
      setTimeout(function () { sg.hidden = true; }, 350);
    }

    for (var i = 0; i < openers.length; i++) { openers[i].addEventListener('click', open); }
    for (var j = 0; j < closers.length; j++) { closers[j].addEventListener('click', close); }
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !sg.hidden) close(); });

    var units = sg.querySelectorAll('.pz-sg-unit');
    var cells = sg.querySelectorAll('td[data-cm]');
    for (var u = 0; u < units.length; u++) {
      (function (btn) {
        btn.addEventListener('click', function () {
          var unit = btn.getAttribute('data-unit');
          for (var k = 0; k < units.length; k++) { units[k].classList.toggle('is-active', units[k] === btn); }
          for (var c = 0; c < cells.length; c++) { cells[c].textContent = cells[c].getAttribute('data-' + unit); }
        });
      })(units[u]);
    }
  }

  /* Description: clamp to 3 lines with an inline "Ver más" toggle (expands to full text + "Ver menos"). */
  function initDescClamp() {
    var el = document.querySelector('.pz-pdp .product__description');
    if (!el) return;
    var fullHTML = el.innerHTML;
    var fullText = el.textContent.replace(/\s+/g, ' ').trim();
    if (!fullText) return;

    var cs = getComputedStyle(el);
    var lh = parseFloat(cs.lineHeight);
    if (isNaN(lh)) lh = parseFloat(cs.fontSize) * 1.5;
    var maxH = lh * 3 + 2;
    if (el.scrollHeight <= maxH) return; // already 3 lines or fewer

    var I = window.pzI18n || {};
    var MORE = ' … <button type="button" class="pz-desc__more">' + (I.seeMore || 'Ver más') + '</button>';

    function collapse() {
      var words = fullText.split(' ');
      var lo = 0, hi = words.length, best = words.slice(0, 1).join(' ');
      while (lo <= hi) {
        var mid = (lo + hi) >> 1;
        el.innerHTML = words.slice(0, mid).join(' ') + MORE;
        if (el.scrollHeight <= maxH) { best = words.slice(0, mid).join(' '); lo = mid + 1; }
        else { hi = mid - 1; }
      }
      el.innerHTML = best.replace(/[\s.,;:]+$/, '') + MORE;
      el.querySelector('.pz-desc__more').addEventListener('click', expand);
    }
    function expand() {
      el.innerHTML = fullHTML;
      var last = el.lastElementChild;
      var target = last && /^(P|DIV|SPAN|LI)$/.test(last.tagName) ? last : el;
      target.insertAdjacentHTML('beforeend', ' <button type="button" class="pz-desc__more">' + (I.seeLess || 'Ver menos') + '</button>');
      el.querySelector('.pz-desc__more').addEventListener('click', collapse);
    }

    collapse();
  }

  /* Sliding selling points: rotate one line at a time under the Add-to-cart button. */
  function initUsp() {
    var box = document.querySelector('[data-pz-usp]');
    if (!box) return;
    var items = box.querySelectorAll('.pz-usp__item');
    if (items.length < 2) return;
    var interval = (parseFloat(box.getAttribute('data-interval')) || 3) * 1000;
    var idx = 0;
    setInterval(function () {
      items[idx].classList.remove('is-active');
      idx = (idx + 1) % items.length;
      items[idx].classList.add('is-active');
    }, interval);
  }

  /* Estimated delivery: main line (delivery date + countdown) and the shipping drawer (country
     switcher, dispatch date, per-country transit range, disclaimer). All dates computed in Madrid
     time: ship date from cutoff/holidays/manual override, transit added as carrier business days. */
  function initEta() {
    var el = document.querySelector('[data-pz-eta]');
    if (!el) return;
    var out = el.querySelector('[data-pz-eta-out]');

    var cur = (el.getAttribute('data-cur') || '').toUpperCase();
    // the shopper's chosen delivery country persists across reloads / products (separate from
    // the footer localization, which drives pricing). Falls back to the localization country.
    var STORE_KEY = 'pz_ship_country';
    function readStored() { try { return localStorage.getItem(STORE_KEY) || ''; } catch (e) { return ''; } }
    function writeStored(v) { try { localStorage.setItem(STORE_KEY, v); } catch (e) {} }
    var stored = readStored();
    var chosenCountry = (stored && /^[A-Z]{2}$/.test(stored)) ? stored : (cur || 'ES');
    var label = el.getAttribute('data-label') || '';
    var urgPrefix = el.getAttribute('data-urgency-prefix') || '';
    var extra = parseInt(el.getAttribute('data-extra'), 10) || 0;
    var hurry = parseInt(el.getAttribute('data-hurry'), 10); if (isNaN(hurry)) hurry = 6;
    var manual = (el.getAttribute('data-manual') || '').trim();
    var holidays = {};
    (el.getAttribute('data-holidays') || '').split(',').forEach(function (s) { s = s.trim(); if (s) holidays[s] = 1; });
    var cutoffRaw = (el.getAttribute('data-cutoffs') || '').split(',');
    var ranges = {
      peninsula: el.getAttribute('data-r-peninsula') || '1-2',
      canarias: el.getAttribute('data-r-canarias') || '3-4',
      e1: el.getAttribute('data-r-e1') || '3-4',
      e2: el.getAttribute('data-r-e2') || '5-7',
      none: el.getAttribute('data-r-none') || '7-14'
    };
    function listOf(attr) { return (el.getAttribute(attr) || '').split(',').map(function (s) { return s.trim().toUpperCase(); }).filter(Boolean); }
    var listE1 = listOf('data-c-e1'), listE2 = listOf('data-c-e2');
    var prices = {
      peninsula: el.getAttribute('data-p-peninsula') || '',
      canarias: el.getAttribute('data-p-canarias') || '',
      e1: el.getAttribute('data-p-e1') || '',
      e2: el.getAttribute('data-p-e2') || '',
      none: el.getAttribute('data-p-none') || ''
    };
    var frees = {
      peninsula: el.getAttribute('data-f-peninsula') || '',
      canarias: el.getAttribute('data-f-canarias') || '',
      e1: el.getAttribute('data-f-e1') || '',
      e2: el.getAttribute('data-f-e2') || '',
      none: el.getAttribute('data-f-none') || ''
    };
    var T = window.pzI18n || {};
    var priceLabel = el.getAttribute('data-price-label') || T.shipCost || 'Precio de envío:';
    var freeLabel = el.getAttribute('data-free-label') || T.freeFrom || 'Envío gratis a partir de:';
    var dispatchPrefix = el.getAttribute('data-dispatch-prefix') || '';
    var dispatchUntil = el.getAttribute('data-dispatch-until') || T.until || 'hasta';
    var dispatchOrigin = el.getAttribute('data-dispatch-origin') || '';
    var transitPrefix = el.getAttribute('data-transit-prefix') || '';
    var transitSuffix = el.getAttribute('data-transit-suffix') || '';
    var arrivePrefix = el.getAttribute('data-arrive-prefix') || T.arrives || 'Llega:';
    var labelPeninsula = el.getAttribute('data-label-peninsula') || T.peninsula || 'España (Península y Baleares)';
    var labelIslands = el.getAttribute('data-label-islands') || T.islands || 'Canarias, Ceuta y Melilla';
    var customsIslands = el.getAttribute('data-customs-islands') || '';
    var customsNonEu = el.getAttribute('data-customs-noneu') || '';

    var WD = T.weekdays || ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
    var MO = T.months || ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
    function parseHM(s) { var m = /^(\d{1,2}):(\d{2})$/.exec((s || '').trim()); return m ? (+m[1]) * 60 + (+m[2]) : null; }
    function fmtHM(min) { var h = Math.floor(min / 60), m = min % 60; return h + ':' + (m < 10 ? '0' : '') + m; }
    var cutMon = [parseHM(cutoffRaw[0]), parseHM(cutoffRaw[1]), parseHM(cutoffRaw[2]), parseHM(cutoffRaw[3]), parseHM(cutoffRaw[4])];
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function key(c) { return c.y + '-' + pad(c.m) + '-' + pad(c.d); }
    function dow(c) { return new Date(Date.UTC(c.y, c.m - 1, c.d)).getUTCDay(); }
    function isHol(c) { return !!holidays[key(c)]; }
    function cutoffOf(c) { var d = dow(c); if (d < 1 || d > 5) return null; return cutMon[d - 1]; }
    function isShipDay(c) { return cutoffOf(c) !== null && !isHol(c); }
    function isTransitDay(c) { var d = dow(c); return d >= 1 && d <= 5 && !isHol(c); }
    function addDays(c, n) { var t = new Date(Date.UTC(c.y, c.m - 1, c.d)); t.setUTCDate(t.getUTCDate() + n); return { y: t.getUTCFullYear(), m: t.getUTCMonth() + 1, d: t.getUTCDate() }; }
    function addTransit(c, n) { var r = c; while (n > 0) { r = addDays(r, 1); if (isTransitDay(r)) n--; } return r; }
    function cmp(a, b) { return (a.y - b.y) || (a.m - b.m) || (a.d - b.d); }
    function parseCivil(s) { var m = /^(\d{4})-(\d{1,2})-(\d{1,2})$/.exec(s || ''); return m ? { y: +m[1], m: +m[2], d: +m[3] } : null; }
    function parseRange(s) { var m = /^(\d+)\s*-\s*(\d+)$/.exec((s || '').trim()); if (m) return { min: +m[1], max: +m[2] }; var n = parseInt(s, 10); return isNaN(n) ? { min: 2, max: 2 } : { min: n, max: n }; }
    function madridNow() {
      var f = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Madrid', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false });
      var p = {}; f.formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
      return { y: +p.year, m: +p.month, d: +p.day, hh: +p.hour, mm: +p.minute };
    }
    function fmt(c) { return WD[dow(c)] + ' ' + c.d + ' ' + MO[c.m - 1]; }
    function zoneFor(cc) {
      cc = (cc || '').toUpperCase();
      if (cc === 'CANARIAS') return 'canarias';
      if (cc === '' || cc === 'ES') return 'peninsula';
      if (listE1.indexOf(cc) >= 0) return 'e1';
      if (listE2.indexOf(cc) >= 0) return 'e2';
      return 'none';
    }
    function shipInfo() {
      var now = madridNow();
      var today = { y: now.y, m: now.m, d: now.d };
      var nowMin = now.hh * 60 + now.mm;
      var todayCutoff = cutoffOf(today);
      var nextShip, shipsToday = false;
      var man = parseCivil(manual);
      if (man && cmp(man, today) >= 0) { nextShip = man; }
      else if (isShipDay(today) && todayCutoff !== null && nowMin < todayCutoff) { nextShip = today; shipsToday = true; }
      else { nextShip = addDays(today, 1); while (!isShipDay(nextShip)) { nextShip = addDays(nextShip, 1); } }
      return { nextShip: nextShip, shipsToday: shipsToday, todayCutoff: todayCutoff, nowMin: nowMin, today: today };
    }
    function fmtDispatch(c, today) {
      if (cmp(c, today) === 0) return T.today || 'hoy';
      if (cmp(c, addDays(today, 1)) === 0) return T.tomorrow || 'mañana';
      return c.d + ' ' + MO[c.m - 1];
    }

    function renderMain() {
      if (!out) return;
      var s = shipInfo();
      var r = parseRange(ranges[zoneFor(chosenCountry)]);
      var del = addTransit(s.nextShip, r.max + extra); // main line uses the latest date
      var html = label + ' <span class="pz-eta__date">' + fmt(del) + '</span>.';
      if (s.shipsToday) {
        var rem = s.todayCutoff - s.nowMin;
        if (rem > 0 && rem < hurry * 60) {
          var h = Math.floor(rem / 60), mi = rem % 60, parts = [];
          if (h > 0) parts.push(h + ' ' + (h === 1 ? (T.hour || 'hora') : (T.hours || 'horas')));
          if (mi > 0) parts.push(mi + ' ' + (mi === 1 ? (T.min || 'min') : (T.mins || 'mins')));
          if (parts.length) html += ' <span class="pz-eta__urgency">' + urgPrefix + ' ' + parts.join(' ') + '.</span>';
        }
      }
      out.innerHTML = html;
    }

    /* ----- shipping drawer ----- */
    // full ISO 3166-1 alpha-2 country list; names resolved to Spanish via Intl.DisplayNames
    var CC = ('AD AE AF AG AI AL AM AO AR AT AU AW AZ BA BB BD BE BF BG BH BI BJ BM BN BO BQ BR BS BT BW BY BZ CA CD CF CG CH CI CK CL CM CN CO CR CU CV CW CY CZ DE DJ DK DM DO DZ EC EE EG ER ES ET FI FJ FK FM FO FR GA GB GD GE GF GG GH GI GL GM GN GP GQ GR GT GU GW GY HK HN HR HT HU ID IE IL IM IN IQ IR IS IT JE JM JO JP KE KG KH KI KM KN KP KR KW KY KZ LA LB LC LI LK LR LS LT LU LV LY MA MC MD ME MF MG MH MK ML MM MN MO MP MQ MR MS MT MU MV MW MX MY MZ NA NC NE NG NI NL NO NP NR NU NZ OM PA PE PF PG PH PK PL PM PR PS PT PW PY QA RE RO RS RU RW SA SB SC SD SE SG SI SK SL SM SN SO SR SS ST SV SX SY SZ TC TD TG TH TJ TL TM TN TO TR TT TV TW TZ UA UG US UY UZ VA VC VE VG VI VN VU WS YE YT ZA ZM ZW').split(' ');

    // ----- shared country picker data (used by BOTH drawers) -----
    var namesI; try { namesI = new Intl.DisplayNames([T.regionLocale || 'es'], { type: 'region' }); } catch (e) { namesI = null; }
    function nameOf(code) { var n = namesI ? namesI.of(code) : null; return n || code; }
    // display label: Spain is split into mainland (ES) and a non-mainland pseudo-zone (CANARIAS)
    function labelOf(code) { if (code === 'ES') return labelPeninsula; if (code === 'CANARIAS') return labelIslands; return nameOf(code); }
    function norm(s) { s = (s || '').toLowerCase(); return s.normalize ? s.normalize('NFD').replace(/[̀-ͯ]/g, '') : s; }
    var countries = CC.map(function (c) {
      var nm = labelOf(c);
      var srch = norm(nm);
      if (c === 'ES') srch = norm(nm + ' espana peninsula baleares islas baleares mallorca menorca ibiza formentera'); // findable by "españa" / "peninsula" / "baleares"
      return { code: c, name: nm, search: srch };
    });
    // add the non-mainland Spain option (Canarias, Ceuta, Melilla) — not a real ISO country. Baleares ships as Península.
    countries.push({ code: 'CANARIAS', name: labelIslands, search: norm(labelIslands + ' espana canarias ceuta melilla islas canarias tenerife gran canaria') });
    countries.sort(function (a, b) { return a.name.localeCompare(b.name, 'es'); });
    // 'CANARIAS' is a valid stored value too (the non-mainland pseudo-zone)
    if (!(chosenCountry && (chosenCountry === 'CANARIAS' || CC.indexOf(chosenCountry) >= 0))) chosenCountry = 'ES';

    // Drawer A (from the ETA line): stock + dispatch + transit + arrive + disclaimer. No price/free.
    function renderDelivery(drawer) {
      var dispatchEl = drawer.querySelector('[data-pz-ship-dispatch]');
      var transitEl = drawer.querySelector('[data-pz-ship-transit]');
      var arriveEl = drawer.querySelector('[data-pz-ship-arrive]');
      var r = parseRange(ranges[zoneFor(chosenCountry)]);
      var s = shipInfo();
      if (dispatchEl) {
        var line = dispatchPrefix + ' ' + fmtDispatch(s.nextShip, s.today);
        if (cmp(s.nextShip, s.today) === 0 && s.todayCutoff != null) { line += ' ' + dispatchUntil + ' ' + fmtHM(s.todayCutoff); }
        if (dispatchOrigin) { line += ' ' + dispatchOrigin; }
        dispatchEl.textContent = line + '.';
      }
      var d1 = addTransit(s.nextShip, r.min + extra), d2 = addTransit(s.nextShip, r.max + extra);
      var rangeTxt = r.min === r.max ? ('' + r.min) : (r.min + '-' + r.max);
      if (transitEl) { transitEl.textContent = transitPrefix + ' ' + labelOf(chosenCountry) + ': ' + rangeTxt + ' ' + transitSuffix + '.'; }
      if (arriveEl) { var arrive = r.min === r.max ? fmt(d2) : (fmt(d1) + ' – ' + fmt(d2)); arriveEl.textContent = arrivePrefix + ' ' + arrive + '.'; }
      renderCustoms(drawer);
    }

    // Drawer B (from the "Envios y devoluciones" tab): price + free-from + time. No stock/dispatch/arrive/disclaimer.
    function renderShipping(drawer) {
      var transitEl = drawer.querySelector('[data-pz-ship-transit]');
      var priceEl = drawer.querySelector('[data-pz-ship-price]');
      var freeEl = drawer.querySelector('[data-pz-ship-free]');
      var r = parseRange(ranges[zoneFor(chosenCountry)]);
      var zk = zoneFor(chosenCountry);
      if (priceEl) { priceEl.textContent = prices[zk] ? (priceLabel + ' ' + prices[zk]) : ''; }
      if (freeEl) { freeEl.textContent = frees[zk] ? (freeLabel + ' ' + frees[zk]) : ''; }
      var rangeTxt = r.min === r.max ? ('' + r.min) : (r.min + '-' + r.max);
      if (transitEl) { transitEl.textContent = transitPrefix + ' ' + labelOf(chosenCountry) + ': ' + rangeTxt + ' ' + transitSuffix + '.'; }
      renderCustoms(drawer);
    }

    // customs / duties note — only for zones where duties can apply (non-mainland ES + non-EU)
    function renderCustoms(drawer) {
      var customsEl = drawer.querySelector('[data-pz-ship-customs]');
      if (!customsEl) return;
      var zk = zoneFor(chosenCountry);
      var note = zk === 'canarias' ? customsIslands : (zk === 'none' ? customsNonEu : '');
      if (note) {
        customsEl.textContent = note; customsEl.hidden = false;
      } else {
        customsEl.textContent = ''; customsEl.hidden = true;
      }
    }

    // generic drawer wiring: country picker + open/close, sharing chosenCountry across drawers
    function buildDrawer(drawer, openerSel, closeAttr, renderContent) {
      if (!drawer) return;
      if (drawer.parentNode !== document.body) { document.body.appendChild(drawer); }
      var picker = drawer.querySelector('[data-pz-ship-picker]');
      var trigger = drawer.querySelector('[data-pz-ship-trigger]');
      var currentEl = drawer.querySelector('[data-pz-ship-current]');
      var panel = drawer.querySelector('[data-pz-ship-panel]');
      var search = drawer.querySelector('[data-pz-ship-search]');
      var listEl = drawer.querySelector('[data-pz-ship-options]');

      if (listEl) {
        countries.forEach(function (co) {
          var li = document.createElement('li');
          li.setAttribute('role', 'option');
          li.setAttribute('data-code', co.code);
          li.setAttribute('data-search', co.search || norm(co.name));
          li.textContent = co.name;
          listEl.appendChild(li);
        });
      }
      function syncPicker() {
        if (currentEl) currentEl.textContent = labelOf(chosenCountry);
        if (!listEl) return;
        var lis = listEl.querySelectorAll('li');
        for (var i = 0; i < lis.length; i++) { lis[i].setAttribute('aria-selected', lis[i].getAttribute('data-code') === chosenCountry ? 'true' : 'false'); }
      }
      function openPanel() { panel.hidden = false; picker.classList.add('is-open'); trigger.setAttribute('aria-expanded', 'true'); if (search) { search.value = ''; filter(''); search.focus(); } }
      function closePanel() { if (!panel) return; panel.hidden = true; if (picker) picker.classList.remove('is-open'); if (trigger) trigger.setAttribute('aria-expanded', 'false'); }
      function filter(q) {
        if (!listEl) return;
        q = norm(q);
        var lis = listEl.querySelectorAll('li');
        for (var i = 0; i < lis.length; i++) { lis[i].classList.toggle('is-hidden', q && lis[i].getAttribute('data-search').indexOf(q) < 0); }
      }
      function setSelected(code) {
        chosenCountry = code; writeStored(code);
        syncPicker();
        renderContent(drawer);
        renderMain();
      }
      if (trigger) trigger.addEventListener('click', function (e) { e.stopPropagation(); if (panel.hidden) openPanel(); else closePanel(); });
      if (search) search.addEventListener('input', function () { filter(search.value); });
      if (listEl) listEl.addEventListener('click', function (e) { var li = e.target.closest('li[data-code]'); if (!li) return; setSelected(li.getAttribute('data-code')); closePanel(); });
      document.addEventListener('click', function (e) { if (picker && !picker.contains(e.target) && panel && !panel.hidden) closePanel(); });

      function open() { syncPicker(); renderContent(drawer); drawer.hidden = false; requestAnimationFrame(function () { drawer.classList.add('is-open'); }); document.documentElement.style.overflow = 'hidden'; document.documentElement.classList.add('pz-sg-open'); }
      function close() { closePanel(); drawer.classList.remove('is-open'); document.documentElement.style.overflow = ''; document.documentElement.classList.remove('pz-sg-open'); setTimeout(function () { drawer.hidden = true; }, 350); }

      var openers = document.querySelectorAll(openerSel);
      for (var i = 0; i < openers.length; i++) {
        (function (op) {
          var summ = op.tagName === 'SUMMARY' ? op : (op.querySelector ? op.querySelector('summary') : null);
          var tgt = summ || op;
          tgt.addEventListener('click', function (e) { if (summ) { e.preventDefault(); } open(); });
          tgt.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); } });
        })(openers[i]);
      }
      var closers = drawer.querySelectorAll('[' + closeAttr + ']');
      for (var j = 0; j < closers.length; j++) { closers[j].addEventListener('click', close); }
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) close(); });

      syncPicker();
      renderContent(drawer);
    }

    renderMain();
    setInterval(renderMain, 30000);
    buildDrawer(document.querySelector('[data-pz-shipguide]'), '[data-pz-ship-open]', 'data-pz-ship-close', renderDelivery);
    buildDrawer(document.querySelector('[data-pz-returnsguide]'), '[data-pz-returns-open]', 'data-pz-returns-close', renderShipping);
  }

  /* Collapsible tabs set to "drawer" mode: the row opens its content in a side drawer instead
     of expanding in place. Reuses the size-guide drawer chrome. */
  function initTabDrawers() {
    var triggers = document.querySelectorAll('[data-pz-tabdrawer-open]');
    if (!triggers.length) return;
    var panels = document.querySelectorAll('[data-pz-tabdrawer]');
    for (var i = 0; i < panels.length; i++) { if (panels[i].parentNode !== document.body) { document.body.appendChild(panels[i]); } }
    function panelFor(id) { return document.querySelector('[data-pz-tabdrawer="' + id + '"]'); }
    function open(panel) {
      if (!panel) return;
      panel.hidden = false;
      requestAnimationFrame(function () { panel.classList.add('is-open'); });
      document.documentElement.style.overflow = 'hidden';
      document.documentElement.classList.add('pz-sg-open');
    }
    function close(panel) {
      if (!panel) return;
      panel.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      document.documentElement.classList.remove('pz-sg-open');
      setTimeout(function () { panel.hidden = true; }, 350);
    }
    for (var t = 0; t < triggers.length; t++) {
      (function (trigger) {
        var id = trigger.getAttribute('data-pz-tabdrawer-open');
        var summary = trigger.querySelector('summary') || trigger;
        summary.addEventListener('click', function (e) { e.preventDefault(); open(panelFor(id)); });
      })(triggers[t]);
    }
    var closers = document.querySelectorAll('[data-pz-tabdrawer-close]');
    for (var c = 0; c < closers.length; c++) {
      (function (cl) { cl.addEventListener('click', function () { close(cl.closest('[data-pz-tabdrawer]')); }); })(closers[c]);
    }
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { var o = document.querySelector('[data-pz-tabdrawer].is-open'); if (o) close(o); } });
  }

  /* "Completa el look" slider: page by exactly one view (N cards), always landing on a
     card boundary so nothing is ever clipped. Native scroll-snap handles mouse/trackpad. */
  function initRelatedSlider() {
    var sliders = document.querySelectorAll('[data-pz-related-slider]');
    for (var i = 0; i < sliders.length; i++) {
      (function (root) {
        var track = root.querySelector('ul.slider');
        var prev = root.querySelector('.slider-button--prev');
        var next = root.querySelector('.slider-button--next');
        if (!track) return;
        function slides() { return track.querySelectorAll('.slider__slide'); }
        function cell() {
          var s = slides();
          if (s.length > 1) { var d = s[1].offsetLeft - s[0].offsetLeft; if (d > 0) return d; }
          if (s.length > 0) { var cs = getComputedStyle(track); return s[0].getBoundingClientRect().width + (parseFloat(cs.columnGap) || 0); }
          return track.clientWidth;
        }
        function maxScroll() { return track.scrollWidth - track.clientWidth; }
        function page(dir) {
          var c = cell();
          // advance exactly one product per click, always landing on a card boundary
          var current = Math.round(track.scrollLeft / c);
          var target = (current + dir) * c;
          target = Math.max(0, Math.min(target, maxScroll()));
          track.scrollTo({ left: target, behavior: 'smooth' });
        }
        function update() {
          var atStart = track.scrollLeft <= 2;
          var atEnd = track.scrollLeft >= maxScroll() - 2;
          if (prev) prev.disabled = atStart;
          if (next) next.disabled = atEnd;
        }
        if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); page(-1); });
        if (next) next.addEventListener('click', function (e) { e.preventDefault(); page(1); });
        track.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        update();
      })(sliders[i]);
    }
  }

  /* Mobile sticky add-to-cart bar. Three states driven by the static ATC button's position:
     - static ATC below the fold           → compact  (button only)
     - static ATC on screen                 → hidden   (use the real button; seamless handoff)
     - static ATC scrolled above the top     → expanded (title + price, then button)
     The sticky button forwards the tap to the real ATC so all cart / size-required logic reuses. */
  function initStickyBar() {
    var bar = document.querySelector('[data-pz-stickybar]');
    if (!bar) return;
    var realBtn = document.querySelector('.product-form__buttons .product-form__submit[name="add"]')
      || document.querySelector('.product-form__submit[name="add"]');
    if (!realBtn) return;

    var stickyBtn = bar.querySelector('[data-pz-stickybar-btn]');
    var stickyBtnText = stickyBtn ? stickyBtn.querySelector('span') : null;
    var priceOut = bar.querySelector('[data-pz-stickybar-price]');
    var staticPrice = document.querySelector('.pz-pdp [id^="price-"]') || document.querySelector('[id^="price-"]');
    var realBtnText = realBtn.querySelector('span');
    var sizes = document.querySelector('[data-pz-sizes]');
    var WARN_RE = /selecciona/i;

    bar.hidden = false;

    // ----- mirror the real button's label (skip the transient "select a size" warn) + disabled state
    function syncButton() {
      if (stickyBtnText && realBtnText) {
        var t = realBtnText.textContent.trim();
        if (t && !WARN_RE.test(t)) stickyBtnText.textContent = t;
      }
      if (realBtn.hasAttribute('disabled')) { stickyBtn.setAttribute('disabled', 'disabled'); }
      else { stickyBtn.removeAttribute('disabled'); }
    }
    // ----- mirror the current price (updates on variant / size change)
    function syncPrice() {
      if (!priceOut || !staticPrice) return;
      var reg = staticPrice.querySelector('.price-item--regular');
      var txt = reg ? reg.textContent.trim() : staticPrice.textContent.trim();
      if (txt) priceOut.textContent = txt;
    }
    syncButton();
    syncPrice();
    try {
      var mo = new MutationObserver(function () { syncButton(); syncPrice(); });
      mo.observe(realBtn, { attributes: true, childList: true, subtree: true, characterData: true });
      if (staticPrice) mo.observe(staticPrice, { childList: true, subtree: true, characterData: true });
    } catch (e) {}

    // ----- tap forwards to the real ATC; if a size is required, surface the size selector
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        if (stickyBtn.hasAttribute('disabled')) return;
        realBtn.click();
        if (realBtn.classList.contains('pz-warn') && sizes) {
          sizes.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    }

    // ----- state machine on scroll
    // distance from the viewport bottom up to the sticky button's TOP — i.e. the exact Y where
    // the static ATC hands off. Compact has no top padding, so this = button height + bottom padding.
    function barHeight() {
      var bh = stickyBtn ? stickyBtn.getBoundingClientRect().height : 48;
      var pb = parseFloat(getComputedStyle(bar).paddingBottom) || 20;
      return bh + pb;
    }
    function update() {
      var r = realBtn.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var mode;
      if (r.bottom <= 0) mode = 'expanded';            // static ATC scrolled above the viewport
      else if (r.top >= vh - barHeight()) mode = 'compact'; // static ATC still below the bar
      else mode = 'hidden';                            // static ATC on screen
      var prev = bar.__pzMode || 'hidden';
      if (mode === prev) return;
      // Animate only when the EXPANDED state is involved (it genuinely slides up/down).
      // compact <-> hidden is instant, so the compact button reads as the same element as
      // the static ATC that replaces it — no slide-to-bottom.
      bar.style.transition = (mode === 'expanded' || prev === 'expanded') ? 'transform 0.28s ease' : 'none';
      bar.classList.toggle('is-compact', mode === 'compact');
      bar.classList.toggle('is-expanded', mode === 'expanded');
      bar.classList.toggle('is-visible', mode !== 'hidden');
      bar.__pzMode = mode;
    }
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { update(); ticking = false; });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  /* Out-of-stock "Notificarme": reveal an email field and post it to Shopify's native contact form
     so the store captures back-in-stock leads (works with no app; connect a back-in-stock app later
     for automatic restock emails). */
  function initNotify() {
    var wrap = document.querySelector('[data-pz-notify]');
    if (!wrap) return;
    var openBtn = wrap.querySelector('[data-pz-notify-open]');
    var panel = wrap.querySelector('[data-pz-notify-panel]');
    var email = wrap.querySelector('[data-pz-notify-email]');
    var submitBtn = wrap.querySelector('[data-pz-notify-submit]');
    var done = wrap.querySelector('[data-pz-notify-done]');
    var err = wrap.querySelector('[data-pz-notify-err]');
    var row = wrap.querySelector('.pz-notify__row');
    var hint = wrap.querySelector('.pz-notify__hint');
    var bodyEl = wrap.querySelector('[data-pz-notify-body]');
    if (!openBtn || !panel) return;

    openBtn.addEventListener('click', function () {
      panel.hidden = false;
      openBtn.setAttribute('aria-expanded', 'true');
      if (email) email.focus();
    });

    function validEmail(v) { return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v); }

    function submit() {
      var v = email ? email.value.trim() : '';
      if (err) err.hidden = true;
      if (!validEmail(v)) { if (email) email.focus(); return; }
      if (submitBtn) submitBtn.disabled = true;
      var fd = new FormData();
      fd.append('form_type', 'contact');
      fd.append('utf8', '✓');
      fd.append('contact[email]', v);
      fd.append('contact[body]', bodyEl ? bodyEl.getAttribute('value') : 'Aviso de reposición');
      fetch('/contact', { method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) {
          if (r.ok || r.redirected) {
            if (row) row.hidden = true;
            if (hint) hint.hidden = true;
            if (done) done.hidden = false;
          } else {
            if (submitBtn) submitBtn.disabled = false;
            if (err) err.hidden = false;
          }
        })
        .catch(function () {
          if (submitBtn) submitBtn.disabled = false;
          if (err) err.hidden = false;
        });
    }

    if (submitBtn) submitBtn.addEventListener('click', submit);
    if (email) email.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); submit(); }
    });
  }

  function boot() { init(); initH(); initSwatches(); initSizes(); initSizeGuide(); initDescClamp(); initUsp(); initEta(); initTabDrawers(); initRelatedSlider(); initStickyBar(); initNotify(); }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
